import { useEffect, ReactNode, useRef } from 'react'

import { useSideNavigationGlobalState } from './use-side-navigation-global-state'
import { ViewportObserver } from './viewport-observer'

import styles from './side-navigation-container.module.scss';


type Props = {
  children: ReactNode
  isWide?: boolean // DEPRECATED
  lock?: boolean
}

const SideNavigationContainer = ({
  children,
  isWide = true, // eslint-disable-line @typescript-eslint/no-unused-vars
  lock = false,
}: Props) => {
  const containerRef = useRef<HTMLDivElement | null>(null)

  const { setLock } = useSideNavigationGlobalState()

  useEffect(() => {
    setLock(lock)
  }, [lock]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ViewportObserver containerRef={containerRef} />
      <div className={styles.root} ref={containerRef}>
        {children}
      </div>
    </>
  )
}

export default SideNavigationContainer
